import { AppTextLabel } from "@@services/i18nservice";
import { AsyncButton } from "@inwink/buttons";
import * as React from "react";

import './cookiebanner.less';


export interface ICookieBannerProps {
    onAccept: () => void;
    onDecline: () => void;
}

export const CookieBanner = (props: ICookieBannerProps) => {
    const [hide, setHide] = React.useState(false);

    if (hide) return null;

    return <div className="cookiebar">
        <div className="cookiebar-overlay" />
        <div className="cookiebar-content">
            <div className="cookiebarmessage">
                <AppTextLabel i18n="cookiebar.title" component="h3" />
                <AppTextLabel i18n="cookiebar.message" component="p" />
            </div>
            <div className="cookiebaractions">
                <AsyncButton className="important" i18nLabel="cookiebar.accept" onClick={() => {
                    props.onAccept();
                    setHide(true);
                }} />
                <AsyncButton i18nLabel="cookiebar.decline" onClick={() => {
                    props.onDecline();
                    setHide(true);
                }} />
            </div>
        </div>
    </div>;
};